import * as Pages from './jsx/pages';
import error404 from './components/error404';

const routes = [
    {
        exact: true,
        path: '/',
        component: Pages.Home,
        key: 'homeRoute',
    },
    {
        exact: true,
        path: '/afiliadas',
        component: Pages.Afiliadas,
        key: 'afiliadasRoute',
    },
    {
        exact: true,
        path: '/ouvir-radio-online',
        component: Pages.AoVivo,
        key: 'aovivoRoute',
    },
    {
        exact: true,
        path: '/artistas/:slug',
        component: Pages.ArtistaInterna,
        key: 'artistasSingleRoute',
    },
    {
        exact: true,
        path: '/artistas',
        component: Pages.Artistas,
        key: 'artistasRoute',
    },
    {
        exact: true,
        path: '/as-10-mais/:slug?',
        component: Pages.As10Mais,
        key: 'top10Route',
    },
    {
        exact: true,
        path: '/as-100-mais/:slug?',
        component: Pages.As100Mais,
        key: 'top100Route',
    },
    {
        exact: true,
        path: '/a1stats',
        component: Pages.A1Stats,
        key: 'a1statsRoute',
    },
    {
        exact: true,
        path: '/contato',
        component: Pages.Contato,
        key: 'contactRoute',
    },
    // {
    //     exact: true,
    //     path: '/jornalistas/:slug',
    //     component: Pages.JornalistasInterna,
    //     key: 'journalistSingleRoute',
    // },
    // {
    //     exact: true,
    //     path: '/jornalistas',
    //     component: Pages.Jornalistas,
    //     key: 'journalistsRoute',
    // },
    {
        exact: true,
        path: '/musicas',
        component: Pages.Musicas,
        key: 'musicsRoute',
    },
    {
        exact: true,
        path: '/musicas/:slug',
        component: Pages.MusicaInterna,
        key: 'musicaRoute',
    },
    {
        exact: true,
        path: '/noticias/tags/:slug',
        component: Pages.NoticiasTags,
        key: 'newsTagsRoute',
    },
    {
        exact: true,
        path: '/noticias/tags',
        component: Pages.Tags,
        key: 'tagsRoute',
    },

    // The Category page is not being used since the agency told us to remove the /categoria/
    // from our url for SEO(?) improvement. To use it again, just uncomment its route in routes.js
    // and its exports in NewsCategory.jsx and index.jsx
    // Also need to uncomment its scss file import on bundle.scss
    /* {
        exact: true,
        path: '/noticias/categoria',
        component: Pages.NewsCategory,
        key: 'newsCategoryRoute'
    }, */
    /* {
        exact: true,
        path: '/noticias',
        component: Pages.Noticias,
        key: 'newsRoute'
    }, */
    {
        exact: true,
        path: '/noticias/:category(musica|saude|economia|politica|tecnologia|outros|mundo|cotidiano|podcast|cinema|moda|carros|gastronomia|viagem)?',
        component: Pages.Noticias,
        key: 'newsRoute',
    },
    {
        exact: true,
        path: '/noticias/:slug',
        component: Pages.NoticiaInterna,
        key: 'newsSingleRoute',
    },
    {
        exact: true,
        path: '/promocoes/:slug',
        component: Pages.PromocaoInterna,
        key: 'singlePromotionRoute',
    },
    {
        exact: true,
        path: '/promocoes',
        component: Pages.Promocoes,
        key: 'promosRoute',
    },
    {
        exact: true,
        path: '/quem-somos',
        component: Pages.QuemSomos,
        key: 'aboutRoute',
    },
    // Archived: restore these routes and page exports to publish podcasts again.
    // {
    //     exact: true,
    //     path: '/podcasts/:type/:slug?',
    //     component: Pages.PodcastSingle,
    //     key: 'podcastRoute',
    // },
    // {
    //     exact: true,
    //     path: '/podcasts',
    //     component: Pages.Podcasts,
    //     key: 'podcastRoute',
    // },
    {
        exact: true,
        path: '/programacao',
        component: Pages.Programacao,
        key: 'programsRoute',
    },
    {
        exact: true,
        path: '/parceiros',
        component: Pages.Parceiros,
        key: 'partnerRoute',
    },
    {
        exact: true,
        path: '/incorporar-player',
        component: Pages.PlayerEmbeddedPage,
        key: 'PlayerEmbeddedPageRoute',
    },
    {
        exact: true,
        path: '/recomende',
        component: Pages.Recomende,
        key: 'recomendeRoute',
    },
    {
        exact: true,
        path: '/trabalhe-conosco',
        component: Pages.TrabalheConosco,
        key: 'trabalheConoscoRoute',
    },
    // {
    //     exact: true,
    //     path: '/videos/:videoTitle?',
    //     component: Pages.Videos,
    //     key: 'videosRoute',
    // },
    {
        exact: true,
        path: '/caca-ao-tesouro',
        component: Pages.CacaAoTesouro,
        key: 'cacaAoTesouroRoute',
    },
    {
        exact: true,
        path: '/busca',
        component: Pages.Busca,
        key: 'buscaRoute',
    },
    {
        exact: true,
        path: '/termos/:slug?',
        component: Pages.Termos,
        key: 'termosRoute',
    },
    {
        exact: true,
        path: '/sitemap',
        component: Pages.SiteMap,
        key: 'siteMapRoute',
    },
    {
        exact: true,
        path: '/aplicativos',
        component: Pages.Aplicativos,
        key: 'aplicativosRoute',
    },
    {
        exact: true,
        path: '/feeds',
        component: Pages.Feeds,
        key: 'feedsRoute',
    },
    {
        exact: true,
        path: '/anuncie-conosco',
        component: Pages.AnuncieConosco,
        key: 'contactRoute',
    },
    {
        exact: true,
        path: '/vantagens-da-assinatura-pro', // Note: /pro is redirected here via 301 from the server.js file
        component: Pages.ProPage,
        key: 'ProPageRoute',
    },
    {
        exact: true,
        path: '/open-app',
        component: Pages.OpenApp,
        key: 'OpenAppRoute',
    },
    {
        exact: true,
        path: '/tv',
        component: Pages.Tv,
        key: 'TvRoute',
    },
    {
        exact: true,
        path: '/clientes/:slug',
        component: Pages.ClientesInterna,
        key: 'clientesSingleRoute',
    },
    {
        exact: true,
        path: '/clientes',
        component: Pages.Clientes,
        key: 'clientesRoute',
    },
    {
        exact: true,
        path: '/perfil/editar-perfil',
        component: Pages.EditarPerfil,
        key: 'editarPerfilRoute',
    },
    {
        component: error404,
        key: 'error404Route',
    },
];

export default routes;
